// @flow
export { default } from './ProductLikeButton';



// WEBPACK FOOTER //
// ./src/components/product/ProductLikeButton/index.js